// extracted by mini-css-extract-plugin
module.exports = {"indicator":"Indicator_indicator__14Tux","indicator-wrapper":"Indicator_indicator-wrapper__3aIpC"};